export const efaAddressBook = {
  efaAddressBook: {
    noAddresses: 'Es sind keine Lieferadressen verfügbar. Bitte kontaktieren Sie den Support.',
    defaultAddress:'Standardadresse'
  }
};
